<template>
    <a-modal v-model:visible="modalConfig.visible" :title="modalConfig.title" @ok="handleOk" @cancel="handleCancel"
        width="840px" class="bom-base-form">
        <a-form :model="formState" :rules="baseFormRules" ref="formRef"
            :label-col="{ style: { width: '120px', marginTop: '10px' } }"
            :wrapper-col="{ style: { width: '260px', marginTop: '10px' } }" layout="inline">
            <a-form-item label="选择物料" :wrapper-col="{ style: { width: '600px', marginTop: '10px' } }" name="materialId">
                <a-space>

                    <a-select v-model:value="searchMaterial" show-search placeholder="请输入物料编码/名称/规格/型号"
                        style="width: 400px" @change="handleChange" allowClear :options="materialTypeData"
                        optionFilterProp="search">
                    </a-select>

                </a-space>
            </a-form-item>

            <a-form-item label="物料编码" name="materialCode">
                <a-input v-model:value="material.materialCode" placeholder="物料编码" disabled></a-input>
            </a-form-item>

            <a-form-item label="物料名称" name="materialName">
                <a-input v-model:value="material.materialName" placeholder="物料名称" disabled></a-input>
            </a-form-item>
            <a-form-item label="物料分类" name="materialSort">
                <a-input v-model:value="material.materialSort" placeholder="物料分类" disabled></a-input>
            </a-form-item>
            <a-form-item label="物料型号" name="type">
                <a-input v-model:value="material.materialModel" placeholder="物料型号" disabled></a-input>
            </a-form-item>
            <a-form-item label="规格" name="specification">
                <a-input v-model:value="material.specification" placeholder="规格" disabled></a-input>
            </a-form-item>
            <!-- <a-form-item label="物料名称">
          <a-input
            v-model:value="material.materialName"
            placeholder="物料名称"
            disabled
          ></a-input>
        </a-form-item> -->
            <a-form-item label="属性" name="attribute">
                <a-input v-model:value="material.attribute" placeholder="属性" disabled></a-input>
            </a-form-item>
            <a-form-item label="版本" name="edition">
                <a-input v-model:value="material.edition" placeholder="版本" disabled></a-input>
            </a-form-item>
            <a-form-item label="代码" name="code">
                <a-input v-model:value="material.code" placeholder="代码" disabled></a-input>
            </a-form-item>
            <a-form-item label="单位" name="unit">
                <a-input v-model:value="material.unit" placeholder="单位" disabled></a-input>
            </a-form-item>
        </a-form>
    </a-modal>
</template>

<script>
import { defineComponent, reactive, ref } from "vue";
import { useRoute } from "vue-router";
import { useStore } from "vuex";
import { insertBOMData, updateBOMDataList, getListByMaterialCode } from "@/request/view/project";
import { materialTypeOptins } from "@/views/materialcode/options";
import { debounce, Toast } from "@/utils";
import { useMaterial } from "@/views/rdmanagement/components/bom/serve/material";

export default defineComponent({
    props: {
        seriesNameConfig: Object,
    },
    setup(props, context) {

        const modalConfig = reactive({
            visible: false,
            title: null,
            type: null,
        });
        // 表单数据
        const formState = reactive({
            id: null,
            inspect: null,
            materialModelCodeId: null,
            edition: null,
            notes: null,
            pid: 0,
            projectLifeCycleId: null,
            seriesOneQuantity: null,
            seriesTwoQuantity: null,
            seriesThreeQuantity: null,
            seriesFourQuantity: null,
            structureName: null,
            userId: null,
            username: null,
            bomFrameName: null,
            isFrame: false,
            materialName: null,
            specification: null,
            type: null,
            orderNumber: null,
            materialCode: null,
            materialModel: null,
            materialSort: null,
            attribute: null,
            code: null,
            unit: null,
        });

        const {
            material,
            materialData,
            searchMaterial,
            searchMaterialType,
            setMaterialType,
            findMaterialData,
            initSearchData,
            resetMaterialData,
            checkSelectedInData,
        } = useMaterial();


        const materialTypeData = reactive([]);

        const getMaterialTypeList = (materialCode) => {
            materialTypeData.length = 0;
            return new Promise((resolve, reject) => {
                getListByMaterialCode({ materialCode }).then((res) => {
                    if (res.code === 200 && res.data && res.data.length > 0) {
                        res.data.forEach((item) => {
                            item.label = `${item.materialName} ${item.materialModel} ${item.edition}`;
                            item.value = item.id;
                            item.search = `${item.materialName}${item.materialCode}${item.specification}${item.materialModel}`;
                            item.materialValue = item.id;
                        });
                        materialTypeData.push(...res.data);
                    }
                    resolve()
                }).catch((err) => {
                    reject()
                });
            });

        };

        const formRef = ref();

        const showModal = async (options) => {
            // 获取物料
            // initSearchData();
            const { title, type, data, materialClassification } = options;
            await getMaterialTypeList(data.materialCode);
            if (materialTypeData.length === 1) return Toast('warning', '物料无多版本', 3);
            modalConfig.title = title;
            modalConfig.type = type;
            // 编辑回显数据
            if (type === "replace") {
                // 回显选中的物料
                searchMaterial.value = `${data.materialName}${data.materialModel}-${data.edition}`;
                Object.keys(material).forEach((key) => {
                    material[key] = data[key];
                });
                Object.keys(formState).forEach((key) => {
                    formState[key] = data[key];
                });
            }

            formState.bomFrameName = materialClassification;

            modalConfig.visible = true;
        };

        // 重置请求表单
        const resetForm = () => {
            Object.keys(formState).forEach((key) => {
                formState[key] = null;
            });

            formState.pid = 0;
            formState.isFrame = false;

            searchMaterial.value = null;
            searchMaterialType.value = undefined;
        };

        const closeModal = () => {
            // 重置物料数据
            resetMaterialData();
            // 重置表单
            resetForm();
            modalConfig.visible = false;
        };

        const handleOk = debounce(() => {
            formRef.value
                .validate()
                .then(() => {
                    updateBOMDataList([formState])
                        .then((res) => {
                            const type = res.code === 200 ? "success" : "warning";
                            Toast(type, res.message, 3);
                            context.emit("updateTable", formState.bomFrameName);
                            closeModal();
                        })
                        .catch((err) => { });
                })
                .catch((err) => {
                    console.log(err);
                    if (err.errorFields) {
                        const errText = err.errorFields[0].errors[0];
                        Toast("warning", errText, 3);
                    }
                });
        }, 50);

        // 重置选中的物料
        const resetSelectMaterial = () => {
            Object.keys(material).forEach((key) => {
                material[key] = null;
            });
            formState.materialModelCodeId = null;
            searchMaterial.value = undefined;
        };
        // 清除表单数据
        const handleCancel = () => {
            resetSelectMaterial();
            resetForm();
        };
        const handleChange = (val, options) => {
            if (val === undefined) {
                resetSelectMaterial();
                initSearchData();
                return;
            }

            searchMaterial.value = val;

            formState.materialModelCodeId = val;

            Object.keys(material).forEach((key) => {
                material[key] = options[key];
                if (key === 'id' || formState[key] === undefined) return
                formState[key] = options[key];
            });

            formState.isFrame = options.type.indexOf("P") !== -1;
        };

        const handleCheckNumber = (e, type) => {
            if (!formState[type]) {
                formState[type] = null;
                return;
            }

            if (isNaN(Number(formState[type]))) {
                formState[type] = null;
            } else {
                formState[type] = Number(formState[type]);
            }
        };

        const handleMaterialChange = (e) => {
            resetSelectMaterial();
            findMaterialData();
        };

        const checkMaterialId = async (rule, value) => {
            const { field, message } = rule;
            if (!formState.materialModelCodeId) {
                return Promise.reject(message);
            }
            return Promise.resolve();
        };

        const handleInspectChange = (e) => {
            formState.inspect = e;
        };

        const baseFormRules = {
            materialId: [
                {
                    required: true,
                    message: "请选择物料",
                    trigger: "change",
                    validator: checkMaterialId,
                },
            ],
        };
        return {
            searchMaterialType,
            materialTypeOptins,
            modalConfig,
            searchMaterial,
            materialData,
            materialTypeData,
            props,
            showModal,
            handleOk,
            handleCancel,
            material,
            debounce,
            handleMaterialChange,
            handleCheckNumber,
            handleChange,
            formState,
            formRef,
            baseFormRules,
            handleInspectChange,
        };
    },
});
</script>

<style lang="less">
.bom-base-form {
    .ant-form-inline .ant-form-item-with-help {
        margin-bottom: 0px;
    }
}
</style>